<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="message.created_at"
      placement="right"
    >
      <div class="from-them">
        <span class="text-left">
          {{ message.message }}
        </span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ["message"]
};
</script>
